import React from "react";
import Icon from "@ant-design/icons";


const StaffAttentionSvg = () => (
    <svg fill="currentColor" width="1em" height="1em" viewBox="0 0 48 48">
        <path d="M24.2,14.9c-.8,0-1.5.7-1.5,1.5v12.3c0,.8.7,1.5,1.5,1.5s1.5-.7,1.5-1.5v-12.3c0-.8-.7-1.5-1.5-1.5Z" />
        <path d="M24.2,32.5c-.8,0-1.5.7-1.5,1.5v.3c0,.8.7,1.5,1.5,1.5s1.5-.7,1.5-1.5v-.3c0-.8-.7-1.5-1.5-1.5Z" />
        <path d="M44.2,37.2L26.9,7.2c-.6-1-1.6-1.6-2.8-1.6h0c-1.2,0-2.2.6-2.8,1.6L4.1,37.2c-.6,1-.6,2.2,0,3.2s1.6,1.6,2.8,1.6h34.6c1.2,0,2.2-.6,2.8-1.6s.6-2.2,0-3.2ZM42,39.1c0,.1-.2.3-.6.3H6.8c-.4,0-.5-.2-.6-.3s-.2-.4,0-.7L23.5,8.5h0c.2-.3.5-.3.6-.3s.4,0,.6.3l17.3,30c.2.3,0,.6,0,.7Z" />
    </svg>
);

const StaffAttentionIcon = (props) => <Icon { ...props } component={ StaffAttentionSvg } />;

export default StaffAttentionIcon;
